/**
 * Store Factory
 *
 * Generates a Vuex module for an event module config.
 * All event modules share the same state shape, only the mutation name differs.
 *
 * @param {object} config - Event module config from eventRegistry
 * @returns {object} Vuex module definition
 */
export function createStoreModule(config) {
  return {
    state: {
      data: {
        applicationUuid: null,
        stageId: null,
        viewId: null,
      },
    },
    getters: {},
    actions: {},
    mutations: {
      [config.storeMutationName](state, data) {
        state.data = data;
      },
    },
  };
}
